module.exports = __webpack_public_path__ + "static/media/icon-awesome-check-circle.38ecc5ee.svg";